<div class="modal-body">


    <!-- <p>La CLABE es un número único e irrepetible asignado a cada cuenta bancaria y tiene por objeto darle mayor
        certeza y seguridad a las transferencias de un banco a otro
    </p>

    <p><strong>¿Dónde puedes encontrar tu CLABE?</strong></p>
    <ul>
        <li>En tus estados de cuenta.</li>
        <li>En tu banca en línea.</li>
        <li>Tu banco te puede decir cuál es tu CLABE interbancaria.</li>
    </ul>

    <p><strong>¿Como se compone la CLABE interbancaria?</strong></p>

    <img src="assets/images/clabe_info.png" alt="clabe info"> -->

    <div class="accordion panel-group">

        <div class="panel panel-default">
            <div class="panel-heading waves-effect">
                <a href="#" class="accordion-link active" aria-expanded="true">
                    <div class="panel-title">¿Qué es la clabe interbancaria?</div>
                    <i class="material-icons accordion-toggle-icon">arrow_downward</i>
                </a>
            </div>
            <div class="content-collapse" aria-expanded="true">
                <div class="panel-body">
                    <p>La CLABE es un número único e irrepetible asignado a cada cuenta bancaria.</p>
                </div>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading waves-effect">
                <a href="#" class="accordion-link">
                    <div class="panel-title">¿Es seguro proporcionar la CLABE?</div>
                    <i class="material-icons accordion-toggle-icon">arrow_downward</i>
                </a>
            </div>
            <div class="content-collapse collapsed">
                <div class="panel-body">
                    La CLABE interbancaria <span style="font-weight: 700;"> sirve para depositarte.</span>
                    Puedes proporcionarla a cualquier
                    persona que requiera hacerte un deposito sin temor de que tus datos estén en peligro.
                </div>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading waves-effect">
                <a href="#" class="accordion-link">
                    <div class="panel-title">¿Para qué la solicitamos?</div>
                    <i class="material-icons accordion-toggle-icon">arrow_downward</i>
                </a>
            </div>
            <div class="content-collapse collapsed">
                <div class="panel-body">
                    Para depositarte en caso de ser aprobado por uno de nuestros prestamistas
                </div>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading waves-effect">
                <a href="#" class="accordion-link">
                    <div class="panel-title">¿Dónde puedes encontrar tu CLABE?</div>
                    <i class="material-icons accordion-toggle-icon">arrow_downward</i>
                </a>
            </div>
            <div class="content-collapse collapsed">
                <div class="panel-body">

                    <p> Puedes encontrarla en tus estados de cuenta, en tu banca en línea o la app de tu banco.</p>

                    <p>
                        <a target="_blank"
                            href="https://www.bbva.mx/educacion-financiera/banca-digital/como-saber-mi-clabe-interbancaria.html">
                            ¿Cómo saber tu clabe interbancaria en <span style="text-decoration: underline;"> BBVA
                            </span>?
                        </a>
                    </p>


                    <p>
                        <a target="_blank"
                            href="https://www.banamex.com/resources/pdf/es/personas/cuentas/clave_nuevo.pdf?viewtype=print&viewclass=print">
                            ¿Cómo saber tu clabe interbancaria en <span
                                style="text-decoration: underline;">Citibanamex</span>?
                        </a>
                    </p>

                    <p>
                        <a target="_blank"
                            href="https://www.banorte.com/wps/portal/banorte/Home/aprende-mas-con-banorte/educacion-financiera/asi-se-compone-la-clabe-interbancaria">
                            ¿Cómo saber tu clabe interbancaria en <span
                                style="text-decoration: underline;">Banorte</span>?
                        </a>
                    </p>

                    <p>
                        <a target="_blank" href="https://www.youtube.com/watch?v=CRU3K6vMCoY">
                            ¿Cómo saber tu clabe interbancaria en <span style="text-decoration: underline;">Banco
                                Azteca?</span>
                        </a>
                    </p>


                    <p>
                        <a target="_blank"
                            href="https://www.facebook.com/HSBCMX/videos/te-compartimos-c%C3%B3mo-consultar-tu-clabe-interbancaria-desde-banca-por-internet-pa/376509937042966/">
                            ¿Cómo saber tu clabe interbancaria en <span style="text-decoration: underline;">HSBC</span>?
                        </a>
                    </p>




                </div>
            </div>
        </div>

    </div>

</div>



<div class="modal-footer">
    <button type="button" class="btn btn-block btn-outline-dark" (click)="modal.close('Save click')">Cerrar</button>
</div>